var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchgreeey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2923 17.8811L15.967 13.5557C16.8607 12.2088 17.3838 10.596 17.3838 8.8623C17.3838 4.16463 13.5619 0.342773 8.86425 0.342773C4.16659 0.342773 0.344727 4.16463 0.344727 8.8623C0.344727 13.56 4.16659 17.3818 8.86425 17.3818C10.598 17.3818 12.2107 16.8587 13.5577 15.965L17.883 20.2904C18.5476 20.9558 19.6278 20.9558 20.2923 20.2904C20.9577 19.625 20.9577 18.5464 20.2923 17.8811ZM2.90058 8.8623C2.90058 5.57376 5.57572 2.89863 8.86425 2.89863C12.1528 2.89863 14.8279 5.57376 14.8279 8.8623C14.8279 12.1508 12.1528 14.826 8.86425 14.826C5.57572 14.826 2.90058 12.1508 2.90058 8.8623Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchgreeey);
export default __webpack_public_path__ + "static/media/searchgreeey.de4f08cf2ab6c48193a50ce8974a01b9.svg";
export { ForwardRef as ReactComponent };